module.exports = __webpack_public_path__ + "static/media/microsoft-logo.f12ef51b.svg";